import React, { useEffect, useRef, Suspense } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";

import models from "../renders/Models.js"; // zie verder

const Loader = () => (
  <div style={{ color: 'white', textAlign: 'center' }}>
    <h1>Model Laden...</h1>
  </div>
);

function Renders() {
  const canvasRef = useRef();

  useEffect(() => {
    let isMounted = true;
    let rafId = null;

    const canvas = canvasRef.current;
    if (!canvas) return;

    // 🧱 SCENE
    const scene = new THREE.Scene();
    scene.background = new THREE.Color(0xffffff);


    // 📷 CAMERA
    const sizes = {
      width: window.innerWidth - 600,
      height: window.innerHeight
    };
    const camera = new THREE.PerspectiveCamera(60, sizes.width / sizes.height, 0.1, 100);
    
    camera.position.set(0, 0, 2);
    scene.add(camera);


    //SCROLL
    let virtualScroll = 0;
    let targetY = 0;

    const scrollSpeed = 0.0001;
    const modelSpacing = 4;
    // const scrollRange = 36; // afstand tussen modellen
    const scrollRange = (models.length - 1.7) * modelSpacing; // afstand tussen modellen
    console.log("scrollrange", scrollRange);

    const onWheel = (event) => {
      virtualScroll += event.deltaY * scrollSpeed;

      virtualScroll = Math.max(0, Math.min(1, virtualScroll));

      targetY = -virtualScroll * scrollRange;
      
    };
    console.log("virtualScroll:", virtualScroll);
    console.log("targetY:", targetY);
    window.addEventListener("wheel", onWheel, { passive: true });

    // 💡 LIGHTS
    const ambient = new THREE.AmbientLight(0xffffff, 1);
    const dirLight = new THREE.DirectionalLight(0xffffff, 2);
    dirLight.position.set(3, 6, 8);
    scene.add(ambient, dirLight);

    //RENDERER
    const renderer = new THREE.WebGLRenderer({
      canvas,
      alpha: true,
      antialias: true,
    });

    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.setSize(sizes.width, sizes.height);
    renderer.shadowMap.enabled = true;
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    renderer.setClearColor(0x000000, 0);    

    // **RODE BAL ALS PLACEHOLDER**
    const placeholderGeometry = new THREE.SphereGeometry(0.1, 5, 5); // Maak een bol met radius 0.5
    const placeholderMaterial = new THREE.MeshStandardMaterial({ color: 0xff0000 }); // Rood materiaal
    const placeholder = new THREE.Mesh(placeholderGeometry, placeholderMaterial);
    placeholder.position.y = 0;
    scene.add(placeholder);
    
    // 🧰 LOADERS
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath("https://www.gstatic.com/draco/v1/decoders/");
    const gltfLoader = new GLTFLoader();
    gltfLoader.setDRACOLoader(dracoLoader);

    
    const loadedModels = [];

    //ANIMATIE
    const animate = () => {
      if (!isMounted) return;

      rafId = requestAnimationFrame(animate);

      // camera volgt scroll
      camera.position.y += (targetY - camera.position.y) * 0.08;
      camera.lookAt(0, camera.position.y, 0);

      // optioneel: lichte rotatie
      loadedModels.forEach((model) => {
        model.rotation.y += 0.001;
      });

      // controls.update();
      renderer.render(scene, camera);
    };

    animate();



    // 📦 ALLE MODELLEN LADEN
    models.forEach(({ path, position, scale }) => {
      gltfLoader.load(path, (gltf) => {
        const model = gltf.scene;
        model.position.set(0, position.y, 0);
        model.scale.set(scale.x, scale.y, scale.z);
        scene.add(model);
        loadedModels.push(model);

        // Verwijder de placeholder na het laden van het model
        scene.remove(placeholder);
      },
      (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + '% geladen');
      },
      (error) => console.error("Fout bij laden model:", path, error)
      );
    });

    // 🔄 RESIZE HANDLER
    const handleResize = () => {
      sizes.width = window.innerWidth-300;
      sizes.height = 5000;
      camera.aspect = sizes.width / sizes.height;
      camera.updateProjectionMatrix();
      renderer.setSize(sizes.width, sizes.height);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    };
    window.addEventListener("resize", handleResize);

    // 🧹 CLEANUP
    return () => {
      isMounted = false;

      if (rafId) cancelAnimationFrame(rafId);

      renderer.dispose();

      scene.clear();

      window.removeEventListener("wheel", onWheel);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Suspense fallback={<Loader />}>
        <div className="Renders">
            <canvas ref={canvasRef} className="insitus__canvas"></canvas>
        </div>
    </Suspense>
  );
}

export default Renders;
